import React from 'react';
interface Icon1Props extends React.SVGProps<SVGSVGElement> {
  style?: React.CSSProperties;
}
export function Icon1(props: Icon1Props) {
  return <div style={{
    filter: 'brightness(0) saturate(100%) invert(16%) sepia(67%) saturate(2851%) hue-rotate(348deg) brightness(92%) contrast(95%)'
  }} data-id="element-167">
      <img src="https://cdn.magicpatterns.com/uploads/fvq4tnGBbdfmZeSPUZMfk9/stripcash-logo.svg" alt="Stripcash" style={{
      width: '200px',
      height: 'auto',
      ...props.style
    }} data-id="element-168" />
    </div>;
}